import React from 'react';
import { Button } from './ui/button';
import { ArrowLeft, Mail, MapPin, HelpCircle } from 'lucide-react';

const LOGO_FALLBACK = 'https://customer-assets.emergentagent.com/job_grocery-saver-4/artifacts/boaapnb1_image%20%281%29.png';

const FAQ = [
  {
    q: 'What is SaleSavor?',
    a: 'SaleSavor is a free grocery-deals app that helps you find nearby grocery stores with current sales, get personalized recipe suggestions, and build smart shopping lists. There are no ads and no in-app purchases.',
  },
  {
    q: 'How does SaleSavor find stores near me?',
    a: 'With your permission, the app uses your device location to look up nearby grocery stores and their current sales. You can also browse using a demo location without sharing your location.',
  },
  {
    q: 'How do I sign in?',
    a: 'You can create an account with your email and password, or use "Sign in with Google."',
  },
  {
    q: 'How do I delete my account and data?',
    a: 'Open the app, go to Settings, scroll to the bottom and tap Delete Account, or email us at info@salesavor.ca with the subject "Delete My Account." See our Delete Account page for full details.',
  },
  {
    q: 'Are the prices shown guaranteed?',
    a: 'Prices and promotions are estimates based on available sales data and may change. Always verify prices, availability, and store policies in-store before purchasing.',
  },
];

const Support = ({ onBack }) => {
  const logoUrl = process.env.REACT_APP_LOGO_URL || LOGO_FALLBACK;
  const handleLogoError = (e) => {
    if (e.target.src !== LOGO_FALLBACK) e.target.src = LOGO_FALLBACK;
  };

  return (
    <div className="min-h-screen" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#FFFFFF' }}>
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <Button onClick={onBack} variant="outline" className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              Back to Home
            </Button>
            <div className="flex items-center gap-3">
              <img
                src={logoUrl}
                alt="SaleSavor App Icon"
                className="h-8 w-8 rounded-lg"
                onError={handleLogoError}
              />
              <span className="text-xl font-bold" style={{ color: '#2c5f2d' }}>
                SaleSavor
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#e8f5e9' }}>
              <HelpCircle className="h-6 w-6" style={{ color: '#2c5f2d' }} />
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold" style={{ color: '#1a1a1a' }}>
              Support &amp; Help
            </h1>
          </div>

          <p className="text-base leading-relaxed mb-8" style={{ color: '#1A1A1A' }}>
            Need help with SaleSavor? We&apos;re here for you. Check the frequently asked questions below,
            or reach out to us directly and we&apos;ll get back to you as soon as we can.
          </p>

          {/* Contact card */}
          <div className="rounded-xl border p-5 sm:p-6 mb-10" style={{ borderColor: '#cfe8d0', backgroundColor: '#E8F5E9' }}>
            <h2 className="text-lg font-bold mb-3" style={{ color: '#1a1a1a' }}>Contact us</h2>
            <div className="flex items-center gap-2 mb-2">
              <Mail className="h-5 w-5" style={{ color: '#2c5f2d' }} />
              <a href="mailto:info@salesavor.ca" className="text-base font-semibold underline" style={{ color: '#2c5f2d' }}>
                info@salesavor.ca
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="h-5 w-5" style={{ color: '#2c5f2d' }} />
              <span className="text-base" style={{ color: '#1A1A1A' }}>Kingston, Ontario, Canada</span>
            </div>
          </div>

          {/* FAQ */}
          <h2 className="text-lg font-bold mb-4" style={{ color: '#1a1a1a' }}>Frequently asked questions</h2>
          <div className="space-y-5">
            {FAQ.map((item, idx) => (
              <div key={idx} className="border-b border-gray-100 pb-5 last:border-b-0">
                <h3 className="text-base font-semibold mb-1.5" style={{ color: '#1a1a1a' }}>{item.q}</h3>
                <p className="text-base leading-relaxed" style={{ color: '#1A1A1A' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
